



















import {Component, Vue} from "vue-property-decorator";
import {Film} from "@/modules/Rhizome/interfaces/film.interface";
import FilmBlock from "@/modules/Rhizome/components/FilmBlock.vue";
import {CoordinatesJsService} from "@/modules/Rhizome/services/coordinates-js.service";
import {Coordinates} from "@/modules/Rhizome/interfaces/coordinates.interface";
import {AnimationJsService} from "@/modules/Rhizome/services/animation-js.service";

@Component({
  components: {
    FilmBlock,
  }
})
export default class RhizomeCloudStatic extends Vue {
  arrayFilms: Film.IFilm[] = [];
  activeLines = [];
  animationJsService: any;

  async created() {
    for (let i = 0; i<= 80; i++) {
      let film: Film.IFilm = {
        id: i,
        title: '',
        description: '',
        imgPreview: '',
        imgLarge: '',
        connectionWith: [],
      };

      for (let j = 0; j < 10; j++) {
        film.connectionWith.push({
          id: this.randomInteger(0, 80),
          weight: 1
        });
      }
      this.arrayFilms.push(film);
    }
  }

  mounted() {
    let arrayCloudFilms: Film.IFilmCloud[] = [];

    this.arrayFilms.forEach((film, index) => {
      let coords = new CoordinatesJsService({
        index,
        viewType: Coordinates.ViewType.cloudStatic,
        canvas: document.querySelector('.rhizome-cloud'),
        centerCoords: {
          left: document.querySelector('.rhizome-cloud').clientWidth / 2,
          top: document.querySelector('.rhizome-cloud').clientHeight / 2,
        },
      });

      this.$refs[`film-${film.id}`][0].style.transform = `translate(${coords.x}px, ${coords.y}px)`;

      let currentDomElement = this.$refs[`film-${film.id}`][0];
      let cloudFilm = {
        ...film,
        originalPosition: {
          x: coords.x,
          y: coords.y,
        },
        originalCenter: {
          x: coords.x + (currentDomElement.querySelector('.preview').scrollWidth / 2),
          y: coords.y + (currentDomElement.querySelector('.preview').scrollHeight / 2),
        },
        scaledSize: {
          width: currentDomElement.querySelector('.preview').scrollWidth * 3.2,
          height: currentDomElement.querySelector('.preview').scrollHeight * 3.2,
        },
        refDomElement: currentDomElement,
      };
      (cloudFilm as Film.IFilmCloud).activeSidesCoords = {
        leftX: coords.x,
        rightX: coords.x + currentDomElement.querySelector('.preview').scrollWidth,
        topY: coords.y,
        bottomY: coords.y + currentDomElement.querySelector('.preview').scrollHeight,
      };
      arrayCloudFilms.push((cloudFilm as Film.IFilmCloud));
    });

    this.animationJsService = new AnimationJsService(arrayCloudFilms);
    setTimeout(() => {
      arrayCloudFilms.forEach(film => {
        let userAgent = navigator.userAgent.toLowerCase();
        let Mozila = /firefox/.test(userAgent);
        if (!Mozila) {
          this.animationJsService.startBrowningMovement(film, true, 15);
        }
        this.addLines(film, true);
      });
    }, 0);
  }

  addLines(film: Film.IFilm, active: boolean = false) {
    let heroVideo = this.$refs[`film-${film.id}`][0];
    if (!heroVideo) return;

    let translate = heroVideo.style.transform.split(' ');
    let translateX = +translate[0].replace(/[^\d.]/g, '');
    let translateY = +translate[1].replace(/[^\d.]/g, '');
    let posVideo = {
      x: translateX + (heroVideo.querySelector('.preview').scrollWidth / 2),
      y: translateY + (heroVideo.querySelector('.preview').scrollHeight * 2.5),
    };

    if (film.connectionWith?.length) {
      film.connectionWith.forEach(connectionLine => {
        let connectedFilm = this.arrayFilms.find((film: Film.IFilm) => film.id === connectionLine.id);
        if (connectedFilm) {
          let item = this.$refs[`film-${connectedFilm.id}`][0];
          if (item) {
            let translate = item.style.transform.split(' ');
            let translateX = +translate[0].replace(/[^\d.]/g, '');
            let translateY = +translate[1].replace(/[^\d.]/g, '');
            let itemPos = {
              x: translateX + (item.querySelector('.preview').scrollWidth / 2),
              y: translateY + (item.querySelector('.preview').scrollHeight * 2.5),
            };

            let pathStr = "M" +
              (posVideo.x) + "," + (posVideo.y) + " " +
              "C" +
              (posVideo.x) + "," + (posVideo.y + ((itemPos.y - posVideo.y) / 2)) + " " +
              (itemPos.x - ((itemPos.x - posVideo.x) / 2)) + "," + (itemPos.y) + " " +
              (itemPos.x) + "," + (itemPos.y);

            let line = {
              path: pathStr,
              weight: connectionLine.weight
            };
            if (active) this.activeLines.push(line);
            else this.activeLines.push(line);
          }
        }
      });
    }
  }

  randomInteger(min: number, max: number) {
    let rand = min + Math.random() * (max + 1 - min);
    return Math.floor(rand);
  }
}
